import { Component, OnInit } from '@angular/core';
import { GenerateSEBConfigModel } from 'src/app/interface/dto';
import { ExamService } from 'src/app/services/exam-service.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { PopoverRef } from 'src/@vex/components/popover/popover-ref';
import { generateSEBConfigModelDefault } from 'src/app/interface/dtoDefaults';
import { Router } from '@angular/router';
import { ExamScheduleService } from 'src/app/services/exam-schedule-service';

@Component({
  selector: 'app-generate-seb-config',
  templateUrl: './generate-seb-config.component.html',
  styleUrls: ['./generate-seb-config.component.scss']
})
export class GenerateSebConfigComponent implements OnInit {

  constructor(private popoverRef: PopoverRef<GenerateSebConfigComponent>, private examService: ExamService, private snackBar: SnackbarService, private route: Router, private examSchServerice: ExamScheduleService) { }
  SEBConfig: GenerateSEBConfigModel = generateSEBConfigModelDefault;
  isExamSchdule: boolean = false;
  async ngOnInit() {
    if (this.route.url === '/exams') {
      if (this.examService.selectedExams?.length === 1) {
        this.SEBConfig.id = this.examService.selectedExams[0].id;
      }
    }
    else {
      if (this.examSchServerice.selectedSchedules.length === 1) {
        this.SEBConfig.id = this.examSchServerice.selectedSchedules[0].id;
        this.isExamSchdule = true;
      }
    }
  }

  async generateConfig() {
    try {
      if (this.isExamSchdule) {
        const res = await this.examSchServerice.generateSEBConfig(this.SEBConfig);
      }
      else {
        const res = await this.examService.generateSEBConfig(this.SEBConfig);
      }

      this.snackBar.success("Config File Created");
      this.close();
    }
    catch (error) {
      this.snackBar.error(error.message);
    }
  }

  close() {
    this.popoverRef.close();
  }
}
